module.exports = __webpack_public_path__ + "static/media/57.f364351e.jpg";